import { data } from "alpinejs/src/datas"

const product = ({ product, variant }) => ({
  urlParams: "",
  variants: null,
  selectedVariant: null,
  selectedSwatch: null,
  currentProduct: null,
  selectedVariantDimensions: null,
  optionRadios: null,
  optionAllRadios: null,
  slider: null,
  selectedVariantImageID: 0,
  productGalleryContainer: null,
  showProductFullSpecs: false,
  productFullSpecsDrawerIsOpen: false,
  productOptionsContainer: null,
  selectedOptionsValuesId: [],
  unavailableVariants: null,
  unavailableOptionsValues: [],
  unavailableVariantsTitles: [],
  selectedOptionPosition: 0,
  hasDimensions: false,
  showStickyButton: false,
  showPopup: false,
  subscriptionModalOpen: false,
  _popupOpener: null,
  _subscriptionOpener: null,
  thumbnailSlider: null,
  mainSlider: null,
  selectedPlan: "subsave",
  hasSellingPlan: false,
  sellingPlanId: null,
  selectedVariantSaleAllocationPrice: null,
  isPlaying: false,
  selectedOptions: [],
  checkedRadios: [],
  productContainer: null,
  activeSlideIndex: null,
  /*hidePauseButton: false,*/
  isAutoplay: false,
  init() {
    this.productContainer = document.querySelector("[data-main-product]")
    this.optionAllRadios = [...document.querySelectorAll("[data-options]")]
    this.checkedRadios = this.optionAllRadios.filter((option) => option.checked)
    if (this.checkedRadios.length) {
      this.checkedRadios.forEach((radio) => {
        this.selectedOptions.push(radio.value)
      })
    }

    const inStockContainer = document.querySelector("[data-form-container]")
    this.urlParams = new URL(window.location.href)
    this.currentProduct = product
    this.variants = product.variants
    this.selectedVariant = variant
    if (this.selectedVariant.featured_media) {
      this.selectedVariantImageID = this.selectedVariant.featured_media.id
    }
    this.productGalleryContainer =
      this.$refs.productGallery ||
      this.productContainer.querySelector(".lsa-product-carousel__slider")
    this.showStickyButton = this.isElementScrolledPast(inStockContainer)
    window.addEventListener("scroll", () => {
      if (inStockContainer) {
        this.showStickyButton = this.isElementScrolledPast(inStockContainer)
      }
    })
    this.drawURL()
    this.$nextTick(() => {
      if (this.selectedVariant?.id) {
        this.slideToSelectedVariantImage(this.selectedVariant.id)
      }
      const slider = this.getMainSlider()
      if (slider) {
        slider.on("slideChange", (event) => this.toggleVideo(event))
      }
      //this.thumbnailSlider.on("slideChange", (event) => this.toggleVideo(event))
    })
  },
  getMainSlider() {
    if (this.mainSlider && typeof this.mainSlider.slideTo === "function") {
      return this.mainSlider
    }

    const sliderElement = this.productContainer.querySelector(
      ".lsa-product-carousel__slider, [data-gallery-main]"
    )

    if (sliderElement && sliderElement.swiper) {
      this.mainSlider = sliderElement.swiper
    }

    return this.mainSlider
  },
  getSelectedVariant(event, variant) {
    this.selectedVariant = this.variants.filter(
      (variant) =>
        variant.title.trim().toLowerCase() ===
        this.optionAllRadios
          .filter((radio) => {
            return radio.checked
          })
          .map((radio) => radio.value)
          .join(" / ")
          .trim()
          .toLowerCase()
    )[0]

    if (this.selectedVariant) {
      window.dispatchEvent(
        new CustomEvent("variant-changed", {
          detail: { variantId: this.selectedVariant.id },
        })
      )

      this.drawURL()
      this.slideToSelectedVariantImage(this.selectedVariant.id)
      this.updateNotifyMeVariantId(this.selectedVariant.id)
    }

    if (this.currentProduct.options.length > 1) {
      this.setAvailableVariants(event)
    }
  },
  updateNotifyMeVariantId(){
    const notifyMeVariantId = document.querySelector("[data-backin-stock-variant-id]")
    if (notifyMeVariantId) {
      notifyMeVariantId.setAttribute("data-backin-stock-variant-id", this.selectedVariant.id)
    }
  },
  setAvailableVariants(event) {
    this.selectedOptionPosition = event.target.getAttribute(
      "data-option-position"
    )
    /*this.selectedOptions[this.selectedOptionPosition] = event.target.value*/
    this.unavailableVariants = this.variants
      .filter(
        (variant) =>
          variant.options[this.selectedOptionPosition] === event.target.value
      )
      .filter((variant) => !variant.available)

    this.unavailableOptionsValues = []
    this.optionAllRadios.forEach((radio) => {
      radio.classList.remove("disabled")
    })

    if (this.unavailableVariants.length) {
      this.unavailableVariants.forEach((variant) => {
        variant.options.forEach((option) => {
          if (event.target.value !== option) {
            this.unavailableOptionsValues.push(option)
          }
        })
      })

      if (this.unavailableOptionsValues.length) {
        this.unavailableOptionsValues.forEach((value) => {
          if (
            this.optionAllRadios.filter((radio) => radio.value === value).length
          ) {
            this.optionAllRadios
              .filter((radio) => radio.value === value)
              .forEach((radio) => {
                radio.classList.add("disabled")
              })
          }
        })
      }
    }

    /*this.selectedOptionPosition = this.selectedVariant.options.indexOf(event.target.value) + 1
    this.unavailableOptionsValues = []
    this.unavailableVariantsTitles = []
    const optionsList = [...document.querySelectorAll(`.options-list`)]
    const notSelectedOptionsList = optionsList.filter(list => +list.getAttribute("data-option-position") !== this.selectedOptionPosition)

    this.unavailableVariants = this.variants.filter((variant) => variant.options.includes(event.target.value)).filter((variant) => !variant.available)
    notSelectedOptionsList.forEach((option, index) => {
        this.optionRadios = option.querySelectorAll("[data-product-variants]")
    })

    this.optionRadios.forEach((radio) => {
        /!*radio.disabled = false*!/
        radio.classList.remove("disabled")
    })

    if (this.unavailableVariants.length > 0) {
        this.unavailableVariants.forEach((variant) => {
            if (!this.unavailableVariantsTitles.includes(variant.title)) {
                this.unavailableVariantsTitles.push(variant.title)
            }
            variant.options.forEach((option) => {
                if (!this.unavailableOptionsValues.includes(option)) {
                    this.unavailableOptionsValues.push(option)
                }
            })
        })
    }

    if (this.unavailableOptionsValues.length > 0) {
        this.unavailableOptionsValues.forEach((value) => {
            this.optionRadios.forEach((radio) => {
                if (radio.value === value && value !== event.target.value) {
                    /!*radio.disabled = true*!/
                    radio.classList.add("disabled")
                }
            })
        })
    }*/
  },
  slideToSelectedVariantImage(id) {
    const jsonEl = document.getElementById(`variant-images-json-${id}`)
    if (!jsonEl?.innerHTML) return
    let data
    try {
      data = JSON.parse(jsonEl.innerHTML)
    } catch {
      return
    }
    const images = data?.images
    if (!Array.isArray(images) || images.length === 0) return

    const mainWrapper = this.productContainer?.querySelector(
      ".lsa-product-carousel__slider .swiper-wrapper"
    )
    const thumbWrapper = this.productContainer?.querySelector(
      ".lsa-product-carousel__thumbs .swiper-wrapper"
    )
    if (!mainWrapper) return

    const escapeAttr = (s) =>
      String(s ?? "")
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")

    const mainSlidesHtml = images
      .map(
        (image, index) => `
      <div class="swiper-slide lsa-product-carousel__slide" data-image-id="${escapeAttr(image.id)}" data-slide-index="${index}">
        <div class="lsa-product-carousel__image-wrapper w-full ratio-3-4 overflow-hidden bg-[#f5f5f5] cursor-pointer">
          <a href="${escapeAttr(image.src)}" data-pswp-width="${image.width ?? ""}" data-pswp-height="${image.height ?? ""}" data-pswp-src="${escapeAttr(image.src)}" class="pswp-gallery__trigger w-full h-full block" data-gallery-index="${index}" aria-label="${escapeAttr(image.alt)}">
            <img src="${escapeAttr(image.src)}" alt="${escapeAttr(image.alt)}" loading="lazy" class="absolute top-0 left-0 object-contain w-full h-full" width="${image.width ?? ""}" height="${image.height ?? ""}">
          </a>
        </div>
      </div>`
      )
      .join("")

    mainWrapper.innerHTML = mainSlidesHtml

    if (thumbWrapper) {
      const thumbSlidesHtml = images
        .map(
          (image, index) => `
      <div class="swiper-slide lsa-product-carousel__thumb cursor-pointer border border-primary-inverse-subdued overflow-hidden" data-slide-index="${index}">
        <div class="relative w-full aspect-square bg-[#f5f5f5]">
          <img src="${escapeAttr(image.src)}" alt="${escapeAttr(image.alt)}" loading="lazy" class="absolute inset-0 w-full h-full object-cover" width="72" height="72">
        </div>
      </div>`
        )
        .join("")
      thumbWrapper.innerHTML = thumbSlidesHtml
    }

    const mainSwiper = this.getMainSlider()
    if (mainSwiper) {
      mainSwiper.updateSlides(true)
      mainSwiper.updateProgress()
      mainSwiper.slideTo(0, 0)
    }
    const thumbEl = this.productContainer?.querySelector(
      "[data-pdp-thumb-desktop].swiper"
    )
    if (thumbEl?.swiper) {
      thumbEl.swiper.updateSlides(true)
      thumbEl.swiper.updateProgress()
      thumbEl.swiper.slideTo(0, 0)
    }
  },
  incrementQty(event) {
    Alpine.store("cart").qty++
  },
  decrementQty(event) {
    if (Alpine.store("cart").qty > 1) {
      Alpine.store("cart").qty--
    }
  },
  drawURL() {
    this.urlParams.searchParams.set("variant", this.selectedVariant.id)
    history.replaceState(this.selectedVariant.id, "variant", this.urlParams)
  },
  changeSellingPlan(event) {
    this.sellingPlanId = event.target.value
    if (
      this.selectedVariant.selling_plan_allocations.find(
        (item) => item.selling_plan_id == this.sellingPlanId
      )
    ) {
      this.selectedVariantSaleAllocationPrice =
        this.selectedVariant.selling_plan_allocations.find(
          (item) => item.selling_plan_id == this.sellingPlanId
        ).price
    }
  },
  switchSubscription(event) {
    this.selectedPlan = event.target.value
  },
  openSubscriptionModal() {
    this._subscriptionOpener = document.activeElement
    this.subscriptionModalOpen = true
  },
  closeSubscriptionModal() {
    this.subscriptionModalOpen = false
    const opener = this._subscriptionOpener
    this._subscriptionOpener = null
    if (opener && typeof opener.focus === 'function') {
      queueMicrotask(() => opener.focus())
    }
  },
  togglePopup() {
    if (!this.showPopup) {
      this._popupOpener = document.activeElement
      this.showPopup = true
      return
    }
    this.showPopup = false
    const opener = this._popupOpener
    this._popupOpener = null
    if (opener && typeof opener.focus === 'function') {
      queueMicrotask(() => opener.focus())
    }
  },
  isElementScrolledPast(el) {
    if (!el) return false
    return el.getBoundingClientRect().bottom < 0
  },
  isElementInViewport(el) {
    if (!el) return false
    const rect = el.getBoundingClientRect()
    return (
      rect.top + el.clientHeight >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    )
  },
  toggleVideo(event) {
    let index_currentSlide = event.realIndex
    let currentSlide = event.slides[index_currentSlide]
    let videoContainer = currentSlide.querySelector(".video-container")
    let playButton = currentSlide.querySelector("button")

    this.stopVideo()

    if (videoContainer) {
      if (this.isAutoplay) {
        this.playVideo(playButton, index_currentSlide)
      }
    }
  },
  playVideo($el, index) {
    const videoContainer = document.querySelectorAll(`[data-slide-index="${index}"]`)
    videoContainer.forEach((container) => {
        if (container.querySelector("video")){
            container.querySelector("video").play()
        }
    })
    this.isPlaying = true
    this.showPauseButton(index)
    this.hidePlayButton(index)
  },
  pauseVideo($el, index) {
    const videoContainer = document.querySelectorAll(`[data-slide-index="${index}"]`)
    videoContainer.forEach((container) => {
        if (container.querySelector("video")){
            container.querySelector("video").pause()
        }
    })
    this.isPlaying = false
    this.hidePauseButton(index)
    this.showPlayButton(index)
  },
    stopVideo(index){
      this.isPlaying = false
      const video = this.productContainer.querySelectorAll("video")
      if (video.length) {
        video.forEach(vid => {
          vid.pause()
          vid.currentTime = 0
        })
      }
      const playButtons = this.productContainer.querySelectorAll("[data-play-button]")
      const pauseButtons = this.productContainer.querySelectorAll("[data-pause-button]")
      if (playButtons){
        playButtons.forEach((button)=>{
          button.classList.remove("!hidden")
        })
      }

      if (pauseButtons){
        pauseButtons.forEach((button)=>{
          button.classList.add("!hidden")
        })
      }
    },
  hidePauseButton(index) {
    const pauseButtons = this.productContainer.querySelectorAll(
      `[data-pause-index="${index}"]`
    )
    if (pauseButtons.length) {
      pauseButtons.forEach((pauseButton) => {
        pauseButton.classList.add("!hidden")

        setTimeout(() => {
          pauseButton.classList.add("opacity-0")
        }, 1000)
      })
    }
  },
  showPauseButton(index) {
    const pauseButtons = this.productContainer.querySelectorAll(
      `[data-pause-index="${index}"]`
    )
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (pauseButtons.length) {
      pauseButtons.forEach((pauseButton) => {
        pauseButton.classList.remove("!hidden")

        setTimeout(() => {
          pauseButton.classList.remove("opacity-0")
        }, 1000)
      })
    }
  },
  showPlayButton(index) {
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (playButtons.length) {
      playButtons.forEach((playButton) => {
        playButton.classList.remove("!hidden")
      })
    }
  },
  hidePlayButton(index) {
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (playButtons.length) {
      playButtons.forEach((playButton) => {
        playButton.classList.add("!hidden")
      })
    }
  },
})

export default product

window.addEventListener("alpine:init", () => {
  Alpine.data("mainProduct", product)
})
